import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import IconComponent from "../../Icons/IconComponent";
import * as BrokerStyles from "../../Broker/Styles.js";
import * as styles from "./Styles.js";

export default function ActionsMenu({ row, onEdit, onDelete }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handleEdit = (event) => {
    handleClose(event);
    onEdit?.(row);
  };

  const handleDelete = (event) => {
    handleClose(event);
    onDelete?.(row);
  };

  return (
    <Box sx={BrokerStyles.ActionCellWrapper}>
      <IconButton sx={BrokerStyles.ActionCircle} onClick={handleOpen}>
        <IconComponent icon="more_vert" size="16px" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleEdit}>
          <EditOutlinedIcon sx={styles.editActionIcon} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.deleteActionItem}>
          <DeleteOutlineIcon sx={styles.deleteActionIcon} />
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
}
